import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import toast from "react-hot-toast";
import ChatIcon from "../../assets/icons/chat.svg";
import EmailIcon from "../../assets/icons/message.svg";
import Input from "../../components/form/input";
import LoadingButton from "../../components/common/loadingButton";
import Textarea from "../../components/form/textarea";
import useStore from "../../features/store";
import { submitTicket } from "../../services/ticket";
import SupportIcon from "../../assets/icons/call.svg";
import { faqData } from "../../data/FAQ";

// Yup validation schema
const schema = yup.object().shape({
  subject: yup.string().required(" موضوع پیام الزامی است"),
  email: yup
    .string()
    .email("فرمت ایمیل اشتباه است")
    .required("ایمیل الزامی است"),
  message: yup.string().required(" متن پیام الزامی است"),
});

const Support = () => {
  //@ts-ignore
  const { profile, isLoadingProfile } = useStore();

  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    control,
    reset,
    ...form
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const onSubmit = (data: any) => {
    const requestBody = {
      name: profile.user.first_name,
      family: profile.user.last_name,
      Phone_number: profile.mobile,
      email: data.email,
      subject: data.subject,
      message: data.message,
    };

    submitTicket(requestBody).then((response) => {
      if (response.status === 201) {
        toast.success("پیام شما را دریافت کردیم.");
        reset();
      } else {
        toast.error("مشکلی در ارسال پیام پیش آمد.");
        reset();
      }
    });
  };

  return (
    <div className="my-5">
      <div className="flex items-center">
        <img src={SupportIcon} width={28} alt="پشتیبانی" />
        <h1 className="font-[800] mr-3 mt-2 font-rokh text-lg">پشتیبانی</h1>
      </div>

      <div className="flex flex-col lg:flex-row items-start justify-between gap-5 my-5">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="w-full flex-1 flex flex-col justify-between"
        >
          <div className="flex-1">
            <Input
              form={form}
              errors={errors}
              title="موضوع پیام"
              icon={<img src={ChatIcon} alt="موضوع پیام" />}
              placeholder=""
              id="subject"
            />
            <Input
              form={form}
              errors={errors}
              title="آدرس ایمیل شما"
              icon={<img src={EmailIcon} alt="ایمیل" />}
              id="email"
              type="email"
              direction="ltr"
            />
            <Textarea
              form={form}
              errors={errors}
              title="متن پیام شما"
              placeholder=""
              id="message"
            />
          </div>

          <LoadingButton
            title="ارسال"
            type="submit"
            disabled={!isValid || !isDirty}
          />
        </form>

        <div className="flex-[1] border rounded-xl p-8 mt-9">
          <div>
            {faqData.map((faqItem: any) => (
              <div className="collapse collapse-arrow bg-base-200 mb-3">
                <input type="radio" name="my-accordion-2" />
                <div className="collapse-title text-sm pt-5 font-bold">
                  {faqItem.question}
                </div>
                <div className="collapse-content">
                  <p className="text-sm">{faqItem.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
